import { api } from './api';

// Específico para lojas business_type = 'catalog'. POST / é público (sem auth),
// só precisa do tenant resolvido (X-Store-Slug ou hostname).

export const leadService = {
  create: async (payload) => {
    // payload: { customerName, customerPhone, customerEmail?, message?, items: [{productVariationId, quantity}] }
    return api.post('/api/leads', payload, { includeAuth: false });
  },

  getAll: async ({ status, page, limit } = {}) => {
    const qs = new URLSearchParams();
    if (status) qs.set('status', status);
    if (page) qs.set('page', page);
    if (limit) qs.set('limit', limit);
    const s = qs.toString();
    return api.get(`/api/leads${s ? `?${s}` : ''}`);
  },

  updateStatus: async (id, status) => {
    return api.patch(`/api/leads/${id}/status`, { status });
  }
};

export default leadService;
